/** @jsxImportSource @emotion/react */
import { Tooltip } from "components/general/Tooltip";
import React, { useCallback } from "react";
import { ratesInfo } from "../../config/commonCSS";
import equal from "../../img/trade-interface/equal.svg";
import { ReactComponent as InfoIcon } from "../../img/trade-interface/info.svg";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Amount } from "../../types/amount";
import { Quote } from "../../types/quote";
import {
  getTokenOut,
  getSellAmountAfterFee,
  isManyToOne,
  isOneToMany,
  isOneToOne,
} from "../../utils/quoteUtils";

export interface WillBeConvertedRowProps {}

const willBeConvertedText = "Amount that will be converted, after the network fee is deducted.";
export const WillBeConvertedRow: React.FC<WillBeConvertedRowProps> = () => {
  const quote = GlobalStore.useState(s => s.quote);
  const theme = GlobalStore.useState(s => s.theme);

  const getAmountAfterFee = useCallback((quote?: Quote): Amount => {
    if (quote) {
      const sellToken = Object.values(quote.takerTokens)[0];
      if (isOneToMany(quote) || isOneToOne(quote)) {
        return getSellAmountAfterFee(quote.makerTokens);
      }
      if (isManyToOne(quote)) {
        return sellToken.amount.sub(Amount.ZERO);
      }
    }
    return Amount.ZERO;
  }, []);

  if (quote == null) {
    return null;
  }
  const symbol = getTokenOut(quote);

  return (
    <>
      <hr className="dashed my-1" />
      <div
        className="d-flex justify-content-between align-items-center"
        data-testid="will-be-converted-row"
      >
        <div className="d-flex align-items-center" style={{ color: theme.font.secondary.default }}>
          <img src={equal} className="pe-2" alt={"Will be converted"} />
          Will be converted
          <Tooltip title={willBeConvertedText}>
            <InfoIcon className="ms-2 d-none d-sm-block" width={12} height={12} />
          </Tooltip>
        </div>
        <>
          <div className="d-flex flex-column align-items-end">
            <span css={ratesInfo}>
              {getAmountAfterFee(quote).format(5)} {symbol}
            </span>
          </div>
        </>
      </div>
    </>
  );
};
